export default Session;

Session.prototype.fetchFields = fetchFields;
Session.prototype.hasFeature = hasFeature;
Session.prototype.hasProfileFeature = hasProfileFeature;
Session.prototype.isReadonly = isReadonly;

function Session(opts) {
    var self = this;

    opts = opts || {};
    Object.assign(this, opts);

    this.isEnterprise = false;
    if(this.user_profile)
        this.isEnterprise = this.user_profile.allow_custom_criteria || false;

    this.features = opts.features || [];
    this.can = {};

    Object.defineProperty(this.can, 'modifyStatus', {
        get: () => !!(this.is_qa || this.is_manager)
    });

    Object.defineProperty(this.can, 'removeItems', {
        get: () => this.is_manager
    });

    Object.defineProperties(this, {
        isSuperuser: { // TODO: Need to rename this! Very confusing! Should be fixed in DOT-166.
            get: () => this.is_qa || this.is_manager || this.is_worker || this.is_staff
        },
        isQA: {  // is QA or higher
            get: () => this.is_qa || this.is_manager || this.is_staff
        },
        isManager: {
            get: () => this.is_manager || this.is_staff
        },
        isCustomer: {
            get: () => false
        },
        isImpersonating: {
            get: () => (this.original_user_email !== null) && (this.email !== this.original_user_email)
        },
        impersonatingMessage: {
            get: () => this.isImpersonating ? `<b>${this.original_user_email}</b> is logged in as <b>${this.email}</b>` : 'No Impersonation'
        }
    });
}

function fetchFields() {
    return Vue.http.get('leadfield/?advanced=false').then(function(res) {
        return res.body;
    });
}

function hasFeature(feature) {
    if (!this.features || !this.features.length) return false;
    return this.features.indexOf(feature) > -1;
}

function hasProfileFeature(feature) {
    const user_profile = this.user_profile;
    if (!user_profile || !user_profile.features || !user_profile.features.length) return false;
    return user_profile.features.indexOf(feature) > -1;
}

function isReadonly(id, status, archived) { // Set permissions per status in the future
    // TODO: Should rewrite this, make more readable
    if (archived) { // Checking permissions for archived Segments/Orgs/Contacts
        if (status === 'needs-enrichment') return true;
    }
    if (!id || id === 0 || id === "0" || !status) return false;
    if (status === 'needs-enrichment') return false;
    if (status === 'client-facing') return true;
    if (!this.isSuperuser) return true;
    if (status === 'needs-fixed') return false;
    if (this.is_manager && (status === 'manager-review' ||
        status === 'qa-review')) return false;
    if (this.is_qa && status === 'qa-review') return false;
    return true;
}
